module.exports = __webpack_public_path__ + "img/Target-green.svg";